import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/config/auth";

/**
 * ProtectedRoute — wraps a tree that requires authentication.
 * If `adminOnly` is true, also requires user.role === "admin".
 */
export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9F8]" data-testid="auth-loading">
        <Loader2 className="w-7 h-7 animate-spin text-[#43A047]" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  if (adminOnly && !isAdmin) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#F8F9F8] p-6" data-testid="forbidden">
        <p className="text-sm text-[#1B291D] font-medium">Admin access required</p>
        <p className="text-xs text-[#617364] mt-1">Your account does not have permission to view this page.</p>
      </div>
    );
  }

  return children;
}
